// src/components/common/NoData.jsx
import { motion } from "framer-motion";

export default function NoData() {
const ballLg = "font-['Gravitas_One'] select-none shrink-0 flex items-center justify-center bg-primary-500 text-base-50 rounded-full w-[clamp(4rem,15vw,10rem)] h-[clamp(4rem,15vw,10rem)] text-[clamp(2rem,8vw,5rem)]";
const ballSm = "font-['Gravitas_One'] select-none shrink-0 flex items-center justify-center bg-primary-500 text-base-50 rounded-full w-[clamp(2rem,8vw,5rem)] h-[clamp(2rem,8vw,5rem)] text-[clamp(1rem,4vw,2.5rem)]";
  return (
    <>
      <div className="max-w-2xl mx-auto py-16 px-4 text-center">
        <h1 className="mb-8 flex justify-center items-end flex-wrap gap-x-2">
          <div className="flex items-end gap-0 lg:translate-x-12">
            <motion.span
              className={`${ballLg} `}
              initial={{ rotate: -30 }}
              animate={{ rotate: 30 }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
            >N</motion.span>
            <motion.span
              className={`${ballSm}`}
              animate={{ rotate: 360 }}
              transition={{ duration: 1.5, repeat: Infinity, ease: [0.4, 0, 0.2, 1] }}
            >O</motion.span>
          </div>
          <div className="flex items-end gap-0 lg:-translate-y-10">
            <motion.span
              className={`${ballLg} `}
              initial={{ rotate: 15 }}
              animate={{ rotate: -15 }}
              transition={{ duration: 1, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
            >D</motion.span>
            <motion.span
              className={`${ballSm}`}
              animate={{ rotate: 360 }}
              transition={{ duration: 9, repeat: Infinity, ease: [0.4, 0, 0.6, 1] }}
            >A</motion.span>
            <motion.span
              className={ballSm}
              style={{ translateY: "-2rem" }}
              animate={{ rotate: [0, -360] }}
              transition={{ duration: 6, repeat: Infinity, ease: "linear", repeatType: "loop" }}
            >T</motion.span>
            <motion.span
              className={`${ballSm}`}
              initial={{ rotate: 195 }}
              animate={{ rotate: 165 }}
              transition={{ duration: 1, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
            >A</motion.span>
          </div>
        </h1>
        <p className="text-primary-500 mt-8">データが見つかりませんでした。</p>
      </div>
    </>
  );
}